var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('shareholder-form',{attrs:{"submit":_vm.update,"submit_btn_text":_vm.$t('btn.submit_changes'),"form_data":_vm.form_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }